<template>
  <div class="flyingBook">
    <img style="width: 50px" src="../../assets/images/loading.gif" alt="" />
  </div>
</template>

<script>
import { getLogo } from '@/utils/intConfiguration';
import {
  setAccount,
  setUserSys,
  setToken,
  // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';
import { getUiFitment } from '@/utils/accessResources';

const { envList } = require('../../../config/dev.proxy');

export default {
  components: {},
  data() {
    return {
      logoUi: getLogo(),
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.init();
  },
  /**
   * 本页面旨在 飞书再次打开的中间页 对传过来的初始化缓存参数 进行存储
   * 01 线上缓存 _this.logoUi.appId 不需要从上级页面带入
   * 02 setToken(res) // 菜单缓存 需要res 从上级页面传入
   * 03 setAccount(res, loginRes) // 菜单缓存 需要res loginRes从上级页面传入
   * 04 进行页面跳转
   */
  methods: {
    init() {
      // eslint-disable-next-line camelcase
      // debugger
      // eslint-disable-next-line camelcase
      const res_data = JSON.parse(decodeURIComponent(this.$route.query.data));
      setToken(res_data.url_res);
      this.initenv();
      setAccount(res_data.url_login_res, res_data.url_res);
      getUiFitment().finally(()=>{
        this.$router.push({
        ...res_data.push,
        });
      })
    },
  },
};
</script>

<style lang="less" scoped>
.flyingBook {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // height: 100%;
  width: 400px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -60%, 0);

  img {
    display: block;

  }

  div {
    // position: absolute;
    text-align: center;
    font-size: 22px;
    margin-top: 16px;
  }
}
</style>
